function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6663 1.40004H2.33301C1.81754 1.40004 1.39967 1.81791 1.39967 2.33337V11.6667C1.39967 12.1822 1.81754 12.6 2.33301 12.6H11.6663C12.1818 12.6 12.5997 12.1822 12.5997 11.6667V2.33337C12.5997 1.81791 12.1818 1.40004 11.6663 1.40004ZM2.33301 0.333374C1.22844 0.333374 0.333008 1.2288 0.333008 2.33337V11.6667C0.333008 12.7713 1.22844 13.6667 2.33301 13.6667H11.6663C12.7709 13.6667 13.6663 12.7713 13.6663 11.6667V2.33337C13.6663 1.2288 12.7709 0.333374 11.6663 0.333374H2.33301Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9001 5.46664C11.1394 5.46664 11.3334 5.27263 11.3334 5.03331C11.3334 4.79399 11.1394 4.59998 10.9001 4.59998H9.16673C8.9274 4.59998 8.7334 4.79397 8.7334 5.03331V8.49998C8.7334 8.7393 8.92741 8.93331 9.16673 8.93331C9.40606 8.93331 9.60007 8.7393 9.60007 8.49998V7.19998H10.9001C11.1394 7.19998 11.3334 7.00597 11.3334 6.76664C11.3334 6.52732 11.1394 6.33331 10.9001 6.33331H9.60007V5.46664H10.9001Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.86667 8.49998V5.03331C7.86667 4.79399 7.67266 4.59998 7.43333 4.59998C7.19401 4.59998 7 4.79399 7 5.03331V8.49998C7 8.7393 7.19401 8.93331 7.43333 8.93331C7.67266 8.93331 7.86667 8.7393 7.86667 8.49998Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.26771 5.46664C5.86283 5.46664 5.86283 4.59998 5.26699 4.59998H3.53366C3.05502 4.59998 2.66699 4.988 2.66699 5.46664V8.06664C2.66699 8.54529 3.05502 8.93331 3.53366 8.93331H5.26699C5.74564 8.93331 6.13366 8.54529 6.13366 8.06664V7.19998C6.13366 6.72133 5.74564 6.33331 5.26699 6.33331H4.83366C4.59434 6.33331 4.40033 6.52732 4.40033 6.76664C4.40033 7.00597 4.59434 7.19998 4.83366 7.19998H5.26699V8.06664H3.53366V5.46664H5.26771Z",
  fill: "white"
});

function SvgIconGif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGif);
export default __webpack_public_path__ + "static/media/icon-gif.506a6698.svg";
export { ForwardRef as ReactComponent };